import { Header } from "./layout/header"

interface Props {
  title?: string
}

export function Title({ title }: Props) {
  return (
    <div lang="ru" className="hyphens-auto text-lg line-clamp-1">
      {title ?? "Загрузка..."}
    </div>
  )
}
export function TitleHeader({ title }: Props) {
  return (
    <Header>
      <Title title={title} />
    </Header>
  )
}
